import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../hooks/redux.js";
import AllActions from "./components/AllActions/AllActions.js";
import ExportActionsModal from "../modals/ExportActionsModal/ExportActionsModal.js";
import RejectedActionsBanner from "../common/RejectedActionsBanner/RejectedActionsBanner.js";
import { SPECIFIC_STORE_IDS } from "../../../constants/storeIds.js";
import { OPEN_MODAL_DUPLICATED_PRODUCTS } from "../../constants/modalTypes.js";
import ActionIdInfoModal from "../modals/ActionIdInfoModal/ActionIdInfoModal.js"
import { openModal } from "../../store/features/modal.js";


const DashboardComponent = () => {
  const rejectedActions = useAppSelector((state) => state.shop.data.rejectedActions);
  const storeId = useAppSelector((state) => state.shop.data.id);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const modalShown = sessionStorage.getItem("modalShown");

    if (!modalShown && SPECIFIC_STORE_IDS.includes(storeId)) {
      dispatch(openModal({ modalType: OPEN_MODAL_DUPLICATED_PRODUCTS }));
      sessionStorage.setItem("modalShown", "true");
    }
  }, []);

  return (
    <>
      {rejectedActions.length > 0 && (
        <RejectedActionsBanner rejectedActions={rejectedActions} />
      )}

      <AllActions />
      <ExportActionsModal />
      <ActionIdInfoModal />
    </>
  );
};

export default DashboardComponent;
